import React from "react";
import { StyleSheet, View } from "react-native";
import "../i18n/i18n";
import { useTranslation } from "react-i18next";
import { IndexPath, Select, SelectItem } from "@ui-kitten/components";
import logError from "../helpers/logError";

const data = ["Polish", "English"];

const LanguageSpinner: React.FC = () => {
    const { i18n } = useTranslation();
    const [selectedIndex, setSelectedIndex] = React.useState(new IndexPath(0));
    const languages = ["pl", "en"];
    const displayValue = data[selectedIndex.row];

    return (
        <View style={[styles.container, styles.backgroundColor]}>
            <Select
                style={[styles.select, styles.backgroundColor]}
                placeholder="Polish"
                value={displayValue}
                selectedIndex={selectedIndex}
                onSelect={(index) => {
                    if (index instanceof IndexPath) {
                        setSelectedIndex(index);
                        i18n.changeLanguage(languages[index.row])
                            .then()
                            .catch((err) => logError(err));
                    }
                }}
            >
                {data.map((title) => (
                    <SelectItem key={title} title={title} />
                ))}
            </Select>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginLeft: "0",
        alignItems: "flex-start",
        maxHeight: "200px",
    },
    select: {
        flex: 1,
        margin: 2,
    },
    backgroundColor: {
        backgroundColor: "#F2F2F2",
    },
});

export default LanguageSpinner;
